function isClickedOutside(event, element) {
  return element && !element.contains(event.target);
}

export default isClickedOutside;
